import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@chilecompra/react-kit'

import { Strong } from './PartnershipGridSection.styles'

/**
 * The PublicPartnershipMessage component.
 */
const PublicPartnershipMessage = ({ hasAffidavit, isForcedAffidavit, partnershipCount }) => {
  if (!hasAffidavit) {
    return (
      <Typography color="black3" fontWeight="regular" margin="18px 0" variant="body2">
        Esta empresa proveedora no posee información disponible sobre sus socios y accionistas.
      </Typography>
    )
  }

  if (isForcedAffidavit) {
    return (
      <>
        <Typography color="black3" fontWeight="regular" margin="18px 0" variant="body2">
          En estos momentos no podemos disponer de forma pública la información de esta empresa proveedora.
        </Typography>

        <Typography color="black3" fontWeight="regular" margin="18px 0" variant="body2">
          Si eres comprador, o perteneces a esta empresa, puedes acceder a esta información iniciando sesión en Mercado
          Público e ingresando a la ficha privada del proveedor.
        </Typography>
      </>
    )
  }

  if (partnershipCount === 0) {
    return (
      <Typography color="black3" fontWeight="regular" margin="18px 0" variant="body2">
        Esta empresa proveedora <Strong>no posee</Strong> socios y accionistas.
      </Typography>
    )
  }

  return null
}

PublicPartnershipMessage.propTypes = {
  hasAffidavit: PropTypes.bool.isRequired,
  isForcedAffidavit: PropTypes.bool.isRequired,
  partnershipCount: PropTypes.number.isRequired
}

export default PublicPartnershipMessage
